<template>
  <v-footer :fixed="!isMobile" color="#292929" height="auto">
    <v-container fluid>
      <v-row justify="center" align="center" no-gutters>
        <template v-if="isMobile">
          <v-col cols="12" class="text-center py-1">
            <v-icon :color="isConstructionRoute ? '#ccac00' : 'red'"
              >mdi-phone</v-icon
            >
            <span class="white--text">Main: (905)-479-3131</span>
          </v-col>
          <v-col cols="12" class="text-center py-1">
            <v-icon :color="isConstructionRoute ? '#ccac00' : 'red'"
              >mdi-phone-in-talk</v-icon
            >
            <span class="white--text">24/7 Emergency: (416)-821-5568</span>
          </v-col>
          <v-col cols="12" class="text-center py-1">
            <v-icon :color="isConstructionRoute ? '#ccac00' : 'red'"
              >mdi-email</v-icon
            >
            <span class="white--text">admin@emswerek.com</span>
          </v-col>
          <v-col cols="12" class="text-center py-2">
            <v-icon :color="isConstructionRoute ? '#ccac00' : 'red'"
              >mdi-copyright</v-icon
            >
            <span class="white--text"
              >{{ new Date().getFullYear() }} EMS WEREK</span
            >
          </v-col>
        </template>
        <template v-else>
          <!-- Desktop layout here, which remains unchanged -->
          <v-icon :color="isConstructionRoute ? '#ccac00' : 'red'"
            >mdi-phone</v-icon
          >
          <span class="white--text mx-2">Main: (905)-479-3131</span>

          <v-icon :color="isConstructionRoute ? '#ccac00' : 'red'"
            >mdi-phone-in-talk</v-icon
          >
          <span class="white--text mx-2">24/7 Emergency: (416)-821-5568</span>

          <v-icon :color="isConstructionRoute ? '#ccac00' : 'red'"
            >mdi-email</v-icon
          >
          <span class="white--text mx-2">admin@emswerek.com</span>

          <v-icon :color="isConstructionRoute ? '#ccac00' : 'red'"
            >mdi-copyright</v-icon
          >
          <span class="white--text mx-2"
            >{{ new Date().getFullYear() }} EMS WEREK</span
          >
        </template>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "pageFooter",
  computed: {
    ...mapGetters(["isMobile"]),
    isConstructionRoute() {
      return this.$route.path === "/services_construction";
    },
  },
};
</script>

<style scoped>
.white--text {
  color: white !important;
}

.v-footer {
  line-height: 1.5; /* Adjust for better readability */
}

/* You might want to add some specific mobile styling here if needed */
.footer-mobile {
  /* Styles for mobile footer */
}
</style>
